import { render } from "./ButtonAccent.vue?vue&type=template&id=6e0a26bc&scoped=true"
import script from "./ButtonAccent.vue?vue&type=script&lang=js"
export * from "./ButtonAccent.vue?vue&type=script&lang=js"

import "./ButtonAccent.vue?vue&type=style&index=0&id=6e0a26bc&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6e0a26bc"]])

export default __exports__